import { useNavigate } from "react-router-dom";
import { CalendarClock, CircleCheck, ListChecks, MessageSquareText } from "lucide-react";

/**
 * Master v5 Prompt 17 — Client 360 Overview: the snapshot already
 * fetched by Client360Page's header query — no second request.
 */
export default function OverviewTab({ workspaceId, memberId, overview }) {
  const navigate = useNavigate();

  const stats = [
    { icon: CalendarClock, label: "Next session", value: overview.next_session_at ? new Date(overview.next_session_at).toLocaleDateString("en-US", { timeZone: "America/Sao_Paulo", month: "short", day: "numeric" }) : "None booked" },
    { icon: CircleCheck, label: "Sessions completed", value: overview.completed_session_count },
    { icon: ListChecks, label: "Journey progress", value: `${overview.journey_done_count}/${overview.journey_stage_count} stages` },
    { icon: MessageSquareText, label: "Message threads", value: overview.thread_count },
  ];

  return (
    <div data-testid="client-360-overview-tab" className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="border border-ink/10 rounded-lg p-3 bg-white/50">
            <s.icon size={16} className="text-ink-soft mb-1.5" />
            <p className="text-lg font-serif text-ink" data-testid={`client-360-overview-${s.label.replace(/\s+/g, "-").toLowerCase()}`}>{s.value}</p>
            <p className="text-xs text-ink-soft">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={() => navigate(`/rehearsal-room/coach/w/${workspaceId}/client/${memberId}/prep`)}
          className="text-sm font-medium bg-terracotta text-paper px-4 py-2 rounded-full hover:bg-terracotta/90 transition-colors"
          data-testid="client-360-overview-prepare-next-session"
        >
          Prepare Next Session
        </button>
      </div>

      <div>
        <h2 className="font-serif text-lg text-ink mb-2">Open tasks</h2>
        {overview.open_tasks.length === 0 ? (
          <p className="text-sm text-ink-soft" data-testid="client-360-overview-no-open-tasks">No open tasks for this client.</p>
        ) : (
          <ul className="space-y-2" data-testid="client-360-overview-open-tasks">
            {overview.open_tasks.map((t) => (
              <li key={t.ctk_id} className="text-sm text-ink border border-ink/10 rounded-lg p-3 bg-white/50 flex items-center justify-between gap-3">
                <span>{t.reason}</span>
                <span className="text-xs text-ink-soft uppercase shrink-0">{t.priority}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
